import { Box, TextField, Typography, InputAdornment, Button } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate } from 'react-router-dom';
import add from '../../assets/icons/e-learning/add_back.svg'
import icon_delete from '../../assets/icons/delete.svg'
import styles from './coordinate.module.css'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import del from '../../assets/icons/e-learning/delete_red.svg'
import * as api from '../services/api'
import Loader from 'components/Loader';

function EditCoordinate() {
    const navigate = useNavigate()
    const location = useLocation()
    const imgRef = useRef(null);
    const fileRef = useRef([]);

    const [loading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null);

    const [itemData, setItemData] = useState()

    const [data, setData] = useState({
        contact_name: '',
        contact_image: null,
        contact_detail: '',
    })

    const [attachment, setAttachment] = useState([
        {
            // fieldname: '',
            // originalname: '',
            // encoding: '',
            // mimetype: '',
            // destination: '',
            // filename: '',
            // path: '',
            // size: '',
            // url: ''
            file_path: '',
            file_source: '',
            file_name: '',
            bucket_name: '',
            original_name: '',
            mime_type: '',
            size: '',
            file_api_url: '',
            file_access_url: ''
        }
    ])

    useEffect(() => {
        let item = location.state.item
        setItemData(item)

        setData({
            ...data,
            contact_name: item['contact_topic'],
            contact_image: item['contact_image_url'],
            contact_detail: item['contact_detail']
        })
        setAttachment(item['contact_attachment_file'])
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value })
    }

    const handleButtonClick = () => {
        imgRef.current.click();
    }
    const handleFileChange = async (event) => {
        // const file = event.target.files && event.target.files[0];

        // let formData = new FormData()
        // formData.append('file', file)

        // setLoading(true)
        // let res = await api.uploadFile2('contact', formData)
        // setLoading(false)
        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         setSelectedFile(res['data']['data']['url'])
        //         setData({ ...data, 'contact_image': res['data']['data']['url'] })
        //     } else {
        //         //alert(res['data']['message'])
        //     }
        // } else {
        //     alert('ไม่ตอบสนอง')
        // }
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_path', `/contact`)
        formData.append('file_source', 'contact')
        formData.append('file_name', file.name)

        setLoading(true)
        let res = await api.uploadFileImage('contact', formData)
        setLoading(false)
        if (!res) return alert('ไม่ตอบสนอง')

        const code = res['code']
        if (code === 200) {
            setSelectedFile(res['data']['file_api_url'])
            setData({ ...data, 'contact_image': res['data']['file_api_url'] })
        } else if (code === 403) {
            alert('ติดต่อสื่อสาร รองรับไฟล์เฉพาะ .pdf, .docx, .xlsx, .ppt, .pptx, .jpeg, .jpg, .png, .txt เท่านั้น')
        } else {
            console.log('error', res)
            alert('ไม่ตอบสนอง')
        }
    }

    const handleButtonClickFile = (index) => {
        fileRef.current[index].click();
    }
    const handleFileChangeFlie = async (e, idx) => {
        // const file = e.target.files && e.target.files[0];
        // if (!file) return

        // let formData = new FormData()
        // formData.append('file', file)

        // setLoading(true)
        // let res = await api.uploadFile2('contact', formData)
        // setLoading(false)
        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         let data = res['data']['data']

        //         let newAttachment = [...attachment];
        //         newAttachment[idx] = data;
        //         setAttachment(newAttachment);
        //     } else {
        //         //alert(res['data']['message'])
        //     }
        // } else {
        //     alert('ไม่ตอบสนอง')
        // }
        const file = e.target.files && e.target.files[0];
        if (!file) return

        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_path', `/contact`)
        formData.append('file_source', 'contact')
        formData.append('file_name', file.name)

        setLoading(true)
        let res = await api.uploadFileImage('contact', formData)
        setLoading(false)
        if (!res) return alert('ไม่ตอบสนอง')

        const code = res['code']
        if (code === 200) {
            let newAttachment = [...attachment];
            newAttachment[idx] = res['data'];
            setAttachment(newAttachment);
        } else if (code === 403) {
            alert('ติดต่อสื่อสาร รองรับไฟล์เฉพาะ .pdf, .docx, .xlsx, .ppt, .pptx, .jpeg, .jpg, .png, .txt เท่านั้น')
        } else {
            console.log('error', res)
            alert('ไม่ตอบสนอง')
        }
    }

    const handClickDeleteAttachment = (index, i) => {
        attachment.splice(index, 1)
        setAttachment([...attachment])
    }

    const handleClickEditFile = () => {
        attachment.push({
            file_path: '',
            file_source: '',
            file_name: '',
            bucket_name: '',
            original_name: '',
            mime_type: '',
            size: '',
            file_api_url: '',
            file_access_url: ''
        })
        setAttachment([...attachment])
    }

    const handleButtonClickEdit = () => {
        let body = {
            "contact_code": itemData['contact_code'],
            "contact_group": itemData['contact_group'],
            "contact_topic": data['contact_name'],
            "contact_image_url": data['contact_image'],
            "contact_detail": data['contact_detail'],
            "contact_attachment_file": attachment,
            "remark": itemData['remark'],
            "doc_status": itemData['doc_status'],
            "created_date": itemData['created_date'],
            "created_user": itemData['created_user'],
            "updated_dated": itemData['updated_dated'],
            "updated_user": itemData['updated_user'],
            "contact_source": itemData['contact_source']
        }
        // console.log(body)
        editContacts(body)
    }

    const editContacts = async (data) => {
        setLoading(true)
        let res = await api.editContacts(data)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                alert('แก้ไขสำเร็จ')
                navigate('/community')
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/community') }}
                    >กลับไป ติดต่อประสานงาน</Box>
                </Box>

                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>แก้ไขข้อมูล</Box>

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'grid',
                    gridGap: '10px'
                }}>
                    <Box>
                        <Box sx={{ fontWeight: 500 }}>หัวข้อ</Box>
                        <TextField
                            size='small'
                            fullWidth
                            placeholder='หัวข้อ'
                            name='contact_name'
                            value={data['contact_name']}
                            onChange={handleChange}
                        />
                    </Box>

                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gridGap: '5px', fontWeight: 500 }}>
                            รูปภาพประกอบ
                            <img
                                style={{ width: '25px', cursor: 'pointer' }}
                                src={add}
                                onClick={handleButtonClick}
                            />
                        </Box>

                        <Box sx={{
                            border: '1px solid #C7C7C7',
                            borderRadius: '5px',
                            padding: '10px',
                            height: '300px'
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', width: 'auto', height: '100%' }}>
                                <input
                                    type="file"
                                    ref={imgRef}
                                    style={{ display: "none" }}
                                    accept=".jpg,.jpeg,.png"
                                    onChange={(e) => {
                                        handleFileChange(e)
                                    }}
                                />
                                <img className={styles.illustration} src={data['contact_image']} />
                                {data['contact_image'] ?
                                    <Box sx={{
                                        display: 'flex',
                                        "@media (max-width: 500px)": {
                                            justifyContent: 'end'
                                        }
                                    }} >
                                        <Box>
                                            <img
                                                src={icon_delete}
                                                style={{ position: 'static', cursor: 'pointer' }}
                                                onClick={() => { setData({ ...data, 'contact_image': null }) }}
                                            />
                                        </Box>
                                    </Box>
                                    : null
                                }
                            </Box>
                        </Box>
                    </Box>

                    <Box>
                        <Box sx={{ fontWeight: 500 }}>รายละเอียด</Box>
                        <TextField
                            size='small'
                            fullWidth
                            multiline
                            rows={4}
                            placeholder='อธิบายที่นี่...'
                            name='contact_detail'
                            value={data['contact_detail']}
                            onChange={handleChange}
                        />
                    </Box>

                    <Box sx={{ display: 'grid', gridGap: '10px' }}>
                        <Box sx={{ fontWeight: 600, display: 'flex', gridGap: '10px' }}>
                            <Box>แนบไฟล์</Box>
                            <img style={{ width: '20px' }} src={add} onClick={() => { handleClickEditFile() }} />
                        </Box>
                        {attachment.map((i, idx) => (
                            <Box sx={{ display: 'grid', gridTemplateColumns: '11fr 50px', gridGap: '5px' }} key={idx}>
                                <Box>
                                    <TextField
                                        fullWidth
                                        size='small'
                                        id='file-upload'
                                        placeholder='แนบไฟล์'
                                        onClick={() => handleButtonClickFile(idx)}
                                        value={i['file_name']}
                                        slotProps={{
                                            input: {
                                                readOnly: true,
                                                startAdornment: <InputAdornment position='start'><AttachFileIcon /></InputAdornment>
                                            }
                                        }}
                                    />
                                    <input
                                        id='file-upload'
                                        type="file"
                                        accept=".pdf,.docx,.xlsx,.ppt,.pptx,.jpeg,.jpg,.png,.txt"
                                        ref={el => fileRef.current[idx] = el}
                                        onChange={(event) => {
                                            handleFileChangeFlie(event, idx)
                                        }}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img src={del} style={{ width: '25px' }} onClick={() => { handClickDeleteAttachment(idx) }} />
                                </Box>
                            </Box>
                        ))}
                    </Box>

                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Button variant='contained' onClick={() => { handleButtonClickEdit() }}>บันทึก</Button>
                </Box>
            </Box>
        </>
    )
}

export default EditCoordinate
